import { AuthContext } from "contexts/auth-context";
import Cookies from "universal-cookie";
import * as types from "../../../redux/types";
import { useContext } from 'react';

const cookies = new Cookies();

const initialState = {
    status:"login",
    time:1,
    userPermission: cookies.get('userPermission') || {}
};

const AuthReducer = (state = initialState, { type, payload }) => {

    switch (type) {
       
        case types.CHANGE_AUTH_SET_PERMISSION: {
            const res = payload;
            cookies.set('userPermission', JSON.stringify(res))
            return {
                ...state,
                userPermission: res,
            };
        }
        case types.CHANGE_AUTH: {
            const { prop, value } = payload;
            return {
                ...state,
                [prop]: value,
            };
        }
        case types.CHANGE_TIMER: {
            const p_time=(state.time - 1)
            return {
                ...state,
                time: p_time

            };
        }
        case types.AUTH_SET_INFO: {
            const res = payload;

            return {
                ...state,

            };
        }
        default:
            return state;
    }
};



export default AuthReducer;
